import { render, staticRenderFns } from "./PersonAdd.vue?vue&type=template&id=6102e868&scoped=true&"
import script from "./PersonAdd.vue?vue&type=script&lang=js&"
export * from "./PersonAdd.vue?vue&type=script&lang=js&"
import style0 from "./PersonAdd.vue?vue&type=style&index=0&id=6102e868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6102e868",
  null
  
)

export default component.exports